import { render, staticRenderFns } from "./CurrencyManagement.vue?vue&type=template&id=9df70546&scoped=true&"
import script from "./CurrencyManagement.vue?vue&type=script&lang=js&"
export * from "./CurrencyManagement.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyManagement.vue?vue&type=style&index=0&id=9df70546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df70546",
  null
  
)

export default component.exports